import React from 'react'
import {connect} from 'react-redux'

import SessionBooker from './session_booker'
import SessionBookConfirmation from './session_book_confirmation'
import SessionCheckoutForm from './session_checkout_form'

// TODO: refactor this to its own module.
export class StartSessionFormStep extends React.Component {
  renderCompletedIcon () {
    if (this.props.isCompleted && !this.props.isActive) {
      return (
        <i className='completed-icon rc-icon-check'/>
      )
    }
  }

  renderBody () {
    if (this.props.isActive) {
      return (
        <div className='step-body'>
          {this.props.children}
        </div>
      )
    }
  }

  render () {
    return (
      <div className={'start-session-step ' + (this.props.isActive ? 'active' : '')}>
        <div className='step-header'>
          <h4 className='step-title'>
            <span>({this.props.step}) {this.props.title}</span>
            {this.renderCompletedIcon()}
          </h4>
        </div>
        {this.renderBody()}
      </div>
    )
  }
}

class StartSessionForm extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      activeStep: 1,
      sessionBookData: null
    }

    this.onSessionBook = this.onSessionBook.bind(this)
    this.onCheckoutComplete = this.onCheckoutComplete.bind(this)
  }

  componentWillMount () {
    if (this.props.bookData) {
      this.setState({
        activeStep: 2,
        sessionBookData: this.props.bookData.toObject()
      })
    }
  }

  onSessionBook (sessionBookData) {
    this.setState({
      sessionBookData,
      activeStep: 2
    })
  }

  onCheckoutComplete (payoutRequestData) {
    this.setState({
      sessionPayoutRequestData: payoutRequestData,
      activeStep: 3
    })
  }

  render () {
    return (
      <div className='start-session-form'>
        <StartSessionFormStep
          step={1}
          isActive={this.state.activeStep === 1}
          isCompleted={this.state.activeStep > 1}
          title='Choose your time'>
          <SessionBooker
            expert={this.props.expert}
            currentUser={this.props.currentUser}
            onSessionBook={this.onSessionBook}/>
        </StartSessionFormStep>
        <StartSessionFormStep
          step={2}
          isActive={this.state.activeStep === 2}
          isCompleted={this.state.activeStep > 2}
          title='Checkout'>
          <SessionCheckoutForm
            expert={this.props.expert}
            user={this.props.currentUser}
            bookData={this.state.sessionBookData}
            onCheckoutComplete={this.onCheckoutComplete}/>
        </StartSessionFormStep>
        <StartSessionFormStep
          step={3}
          isActive={this.state.activeStep === 3}
          isCompleted={this.state.activeStep > 3}
          title='Confirmation'>
          <SessionBookConfirmation
            expert={this.props.expert}
            currentUser={this.props.currentUser}
            sessionPayoutRequestData={this.state.sessionPayoutRequestData}
            bookData={this.state.sessionBookData}/>
        </StartSessionFormStep>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.get('currentUser')
  }
}

const StartSessionFormContainer = connect(
  mapStateToProps
)(StartSessionForm)

export default StartSessionFormContainer



/** WEBPACK FOOTER **
 ** ./modules/shared/start_session_form.js
 **/